import { Berth } from './Berth';

export class BerthData {
    constructor(berthList: Berth[]) {
        this.berthList = berthList;
    }
    berthList: Berth[];
}
